import { SORT_ORDER } from '@evinced-private/ui-common';

import { preprocessSearchValue } from 'src/apps/mobile-common/helpers/MobileSearchHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import { RUN_ID_PARAM_NAME } from 'src/common/services/queries/CommonParams';
import {
	IssuesSortFields,
	IssuesSortOrder,
	IssuesTextSearchFields
} from 'src/common/types/graphql.generated';

import { IGetMfaSessionAllIssuesParams } from '../../../MfaDashboardServiceTypes';
import { MfaSessionIssuesQueryVariables } from '../MfaSessionIssues.generated';

const issuesSortFieldNamesMap: Record<string, IssuesSortFields> = {
	type: IssuesSortFields.TypeName,
	severity: IssuesSortFields.SeverityName,
	pageTitle: IssuesSortFields.PageTitle,
	scanName: IssuesSortFields.ScanName,
	platform: IssuesSortFields.Os
};

const issuesSortOrderMap: Record<SORT_ORDER, IssuesSortOrder> = {
	[SORT_ORDER.ASC]: IssuesSortOrder.Ascending,
	[SORT_ORDER.DESC]: IssuesSortOrder.Descending
};

const issuesSearchFields = [
	IssuesTextSearchFields.TypeName,
	IssuesTextSearchFields.SeverityName,
	IssuesTextSearchFields.ScanName,
	IssuesTextSearchFields.ElementsAccessibilityLabel,
	IssuesTextSearchFields.ElementsAccessibilityIdentifier,
	IssuesTextSearchFields.ElementsElementType,
	IssuesTextSearchFields.ElementsContentDescription,
	IssuesTextSearchFields.ElementsViewId,
	IssuesTextSearchFields.ElementsClassName,
	IssuesTextSearchFields.ElementsId,
	IssuesTextSearchFields.ElementsIndex,
	IssuesTextSearchFields.ElementsComponentId
];

const SEVERITY_ID_FILTER_PARAM_NAME = 'severityIdFilter';
const TYPE_ID_FILTER_PARAM_NAME = 'typeIdFilter';
const SCAN_NAME_FILTER_PARAM_NAME = 'scanNameFilter';

export const buildMfaSessionIssuesVariables = (
	params: IGetMfaSessionAllIssuesParams
): MfaSessionIssuesQueryVariables => {
	const { sessionId, filterOptions, sort, page = 0, pageSize = 10 } = params;
	const variablesBuilder = new QueryVariablesBuilder<MfaSessionIssuesQueryVariables>({
		searchFields: issuesSearchFields,
		sortFieldsMap: issuesSortFieldNamesMap,
		sortOrderMap: issuesSortOrderMap
	});

	const searchValues = preprocessSearchValue(filterOptions?.searchValue ?? '');

	return variablesBuilder
		.addPaginationParams(page, pageSize)
		.addSortParam(sort)
		.addTextSearchParam(searchValues)
		.addConditionParam(RUN_ID_PARAM_NAME, sessionId)
		.addFilterParam(SEVERITY_ID_FILTER_PARAM_NAME, filterOptions?.severities)
		.addFilterParam(TYPE_ID_FILTER_PARAM_NAME, filterOptions?.types)
		.addFilterParam(SCAN_NAME_FILTER_PARAM_NAME, filterOptions?.scans)
		.getVariables();
};
